import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const VersionContext = createContext({ version: "…", build_date: "", codename: "", changelog: [], loading: true });

export function VersionProvider({ children }) {
  const [info, setInfo] = useState({ version: "…", build_date: "", codename: "", changelog: [], loading: true });

  useEffect(() => {
    let cancelled = false;
    api.get("/version")
      .then((r) => { if (!cancelled) setInfo({ ...r.data, loading: false }); })
      .catch(() => { if (!cancelled) setInfo({ version: "?", build_date: "", codename: "", changelog: [], loading: false }); });
    return () => { cancelled = true; };
  }, []);

  return <VersionContext.Provider value={info}>{children}</VersionContext.Provider>;
}

export function useVersion() {
  return useContext(VersionContext);
}

export function formatVersion(info) {
  if (!info || !info.version) return "v?";
  return `v${info.version}`;
}
